import { Skeleton } from "@components/wrapper";
import { useIsShopsite } from "@context/DomainContext";

const SkeletonLoading = () => {
  const isShopsite = useIsShopsite();

  if (isShopsite) {
    return (
      <>
        <div className="hidden sm:block max-sm:-mx-4 max-sm:-my-2 border bg-white border-gray-200 sm:rounded-lg overflow-hidden relative animate-pulse">
          <div className="w-full">
            <div className="flex w-full p-4 border-b border-gray-300">
              <h3 className="h-5 w-full bg-gray-200 rounded-md" />
            </div>
            <ul className="p-4 space-y-4">
              <li className="w-full h-4 bg-gray-200 rounded-md" />
              <li className="w-full h-4 bg-gray-200 rounded-md" />
              <li className="w-full h-4 bg-gray-200 rounded-md" />
              <li className="w-full h-4 bg-gray-200 rounded-md" />
            </ul>
          </div>
        </div>
        <div className="sm:hidden flex flex-col gap-4 px-2 pb-2">
          {Array.from({ length: 4 }).map((_, index) => (
            <div
              key={index}
              className="w-full  rounded-xl bg-gray-200 animate-pulse h-20"
            />
          ))}
        </div>
      </>
    );
  }

  return <Skeleton className="h-[80px] sm:h-[140px]" />;
};

export default SkeletonLoading;
